module.exports = __webpack_public_path__ + "img/materials_en.3f33650.jpg";